/* eslint-disable no-plusplus */
export default function preloadMedia(mediaItems) {
  return new Promise((resolve) => {
    const validMediaItems = mediaItems.filter(
      (item) =>
        item?.url &&
        (item?.mediaType === 'photo' || item?.mediaType === 'video')
    );
    const totalItems = validMediaItems.length;

    if (totalItems === 0) resolve();

    let loadedCount = 0;
    const handleLoad = () => {
      loadedCount++;

      if (loadedCount === totalItems) {
        resolve();
      }
    };

    validMediaItems.forEach((item) => {
      if (item.mediaType === 'photo') {
        const img = new Image();

        img.src = item.url;
        img.onload = handleLoad;
        img.onerror = handleLoad;
      } else if (item.mediaType === 'video') {
        const video = document.createElement('video');

        video.src = item.url;
        video.oncanplaythrough = handleLoad;
        video.onerror = handleLoad;
        video.onstalled = handleLoad;
      }
    });
  });
}
